import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Header } from '@/components/Header';
import { HomePage } from '@/pages/HomePage';
import { APP_VERSION } from '@/version';
import '@/styles/global.css';
import '@/styles/header.css';
import '@/styles/trailer.css';
import '@/styles/layout-switch.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Header />
    <HomePage />
    <div style={{
      position: 'fixed',
      bottom: '0.4rem',
      left: '50%',
      transform: 'translateX(-50%)',
      fontSize: '0.65rem',
      color: 'rgba(255,255,255,0.5)',
      fontFamily: 'var(--font-sans)',
      pointerEvents: 'none',
      zIndex: 9999,
    }}>
      v{APP_VERSION}
    </div>
  </StrictMode>,
);
